import React, { useMemo, useState } from "react";
import "./Questions.scss";
import { LANDING_FAQ_DEFAULTS, LANDING_FAQ_SUBTITLE } from "../content/landingContent";
import { usePlatformSettingsPublic } from "../hooks/usePlatformSettingsPublic";

const faqData = LANDING_FAQ_DEFAULTS;

export default function Questions() {
  const { data: platformSettings } = usePlatformSettingsPublic();
  const adminFaq = platformSettings?.landingFaq || platformSettings?.faq;
  const adminFaqSubtitle =
    platformSettings?.landingFaqSubtitle || platformSettings?.faqSubtitle;
  const adminFaqTitle = platformSettings?.landingFaqTitle || platformSettings?.faqTitle;

  const normalizedFaqData = useMemo(() => {
    if (!Array.isArray(adminFaq)) return faqData;
    const sanitized = adminFaq
      .map((item) => ({
        question: String(item?.question || item?.q || "").trim(),
        answer: String(item?.answer || item?.a || "").trim(),
      }))
      .filter((item) => item.question && item.answer);
    return sanitized.length > 0 ? sanitized : faqData;
  }, [adminFaq]);

  const subtitle =
    String(adminFaqSubtitle || "").trim() ||
    LANDING_FAQ_SUBTITLE;

  const title = String(adminFaqTitle || "").trim() || "Frequently Asked Questions";

  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className="questions_section" id="landing-faq">
      <div className="questions_header">
        <span className="questions_kicker">Help Center</span>
        <h2>{title}</h2>
        <p className="subtitle">{subtitle}</p>
      </div>

      <div className="faq_wrapper">
        {normalizedFaqData.map((item, index) => (
          <div
            key={index}
            className={`faq_item ${activeIndex === index ? "active" : ""}`}
          >
            <button
              type="button"
              className="faq_question"
              aria-expanded={activeIndex === index}
              aria-controls={`faq-answer-${index}`}
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              <span><h3>{item.question}</h3></span>
              <span
                className={`icon_qus faq_chevron ${activeIndex === index ? "faq_chevron_open" : ""}`}
                aria-hidden="true"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9l6 6 6-6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>

            {activeIndex === index && (
              <div className="faq_answer" id={`faq-answer-${index}`}><p>{item.answer}</p></div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
